import { useEffect, useState } from "react";

import { fetchSiteContent } from "../lib/siteContentApi";

export const useHomeContent = () => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isActive = true;

    const loadContent = async () => {
      setIsLoading(true);
      setError("");

      try {
        const result = await fetchSiteContent("home");

        if (isActive) {
          setContent(result.value || null);
        }
      } catch (loadError) {
        if (isActive) {
          setError(loadError.message || "Unable to load website content.");
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    loadContent();

    return () => {
      isActive = false;
    };
  }, []);

  return { content, isLoading, error };
};
